






import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({})
export default class SidebarNavItem extends Vue {
  @Prop({ default: "" })
  public classes: string;

  @Emit()
  public hideMobile() {
    if (document.body.classList.contains("sidebar-mobile-show")) {
      document.body.classList.toggle("sidebar-mobile-show");
    }
  }

  get classList() {
    return ["nav-item", ...this.itemClasses];
  }

  get itemClasses() {
    return this.classes ? this.classes.split(" ") : [];
  }
}
